import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Suggerimento } from '../models/suggerimento';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class SuggerimentoService extends ResourcefulService<Suggerimento>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Suggerimento);
    }
}
